import React, { Component } from "react";
import { toPersianNumber } from "../../../classes/utils";

import image from "../../../logo.png";

const PrintOrders = (props) => {
    let { orders } = props;
    return (
        <html>
            <head>
                <title>سفارشات</title>
            </head>
            <body>
                {orders.map((order) => {
                    return (
                        <div
                            className="page"
                            style={{
                                padding: "10px",
                                height: "305mm",
                                width: "210mm",
                                direction: "rtl",
                                position: "relative",
                                backgroundColor: "rgba(0,0,0,.1)",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                            }}
                            key={order.id}
                        >
                            <div
                                className="invoice"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    position: "relative",
                                    textAlign: "right",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <div>
                                    <img
                                        src={image}
                                        style={{
                                            width: "20mm",
                                            aspectRatio: 1,
                                        }}
                                    />
                                    فروشگاه اینترنتی نیکا
                                </div>

                                <div
                                    style={{
                                        textAlign: "center",
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "100%",
                                        justifyContent: "space-evenly",
                                        borderBottom:
                                            "1px solid rgba(0,0,0,0.3)",
                                    }}
                                >
                                    <div>شماره سفارش</div>
                                    <div>{toPersianNumber(order.id)}</div>
                                </div>

                                <div
                                    style={{
                                        textAlign: "right",
                                        display: "flex",
                                        flexDirection: "column",
                                        width: "100%",
                                        borderBottom:
                                            "1px solid rgba(0,0,0,0.3)",
                                    }}
                                >
                                    <div>{order.name}</div>
                                    <div>
                                        {toPersianNumber(
                                            order.costumerMobile || order.mobile
                                        )}
                                    </div>
                                    <div>
                                        {`${order.province_name} -
                                            ${order.city_name} - 
                                            ${order.address}`}
                                    </div>
                                    <div>{toPersianNumber(order.zip)}</div>
                                </div>

                                <table
                                    style={{
                                        lineHeight: 1.5,
                                        borderCollapse: "collapse",
                                        fontWeight: 900,
                                    }}
                                >
                                    <thead>فاکتور</thead>
                                    <tbody>
                                        {order.items.map((item, index) => {
                                            return (
                                                <tr
                                                    key={index}
                                                    style={{
                                                        borderBottom:
                                                            "1px solid rgba(0,0,0,0.3)",
                                                    }}
                                                >
                                                    <td>{item.name}</td>
                                                    <td
                                                        style={{
                                                            padding: "5px 30px",
                                                        }}
                                                    >
                                                        {toPersianNumber(
                                                            item.amount,
                                                            true
                                                        )}
                                                        {item.unit}
                                                    </td>
                                                    <td
                                                        style={{
                                                            padding: "5px 30px",
                                                        }}
                                                    >
                                                        {toPersianNumber(
                                                            order.check[index]
                                                                .price,
                                                            true
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        <tr
                                            style={{
                                                borderBottom: "3px solid black",
                                            }}
                                        >
                                            <td>قیمت کل اجناس</td>
                                            <td></td>

                                            <td style={{ padding: "5px 30px" }}>
                                                {toPersianNumber(
                                                    order.totalItemsPrice,
                                                    true
                                                )}
                                            </td>
                                        </tr>
                                        <tr
                                            style={{
                                                borderBottom: "3px solid black",
                                            }}
                                        >
                                            <td>هزینه بسته بندی</td>
                                            <td></td>

                                            <td style={{ padding: "5px 30px" }}>
                                                {toPersianNumber(
                                                    order.packingPrice,
                                                    true
                                                )}
                                            </td>
                                        </tr>
                                        <tr
                                            style={{
                                                borderBottom: "3px solid black",
                                            }}
                                        >
                                            <td>هزینه ارسال</td>
                                            <td></td>

                                            <td style={{ padding: "5px 30px" }}>
                                                {toPersianNumber(
                                                    order.shipping_cost,
                                                    true
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>قیمت کل </td>
                                            <td></td>

                                            <td
                                                style={{
                                                    padding: "5px 30px",
                                                    border: "3px solid black",
                                                }}
                                            >
                                                {toPersianNumber(
                                                    order.total,
                                                    true
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    );
                })}
            </body>
        </html>
    );
};

export default PrintOrders;
